import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import './index.css';
import App from './App';
import WorkerView from './WorkerView';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const isWorkersRoute =
  window.location.pathname === '/workers' ||
  window.location.pathname === '/workers/';

if (isWorkersRoute) {
  root.render(
    <React.StrictMode>
      <WorkerView />
    </React.StrictMode>
  );
} else {
  const msalInstance = new PublicClientApplication(msalConfig);

  // MSAL v5: initialize() zpracuje pending redirect response a nastaví accounts
  // PŘED prvním renderem — bez toho accounts.length === 0 při návratu z redirectu
  // a App.tsx by spustil loginRedirect znovu (smyčka).
  msalInstance.initialize().then(() => {
    // Po initialize() nastav active account, pokud existuje
    const all = msalInstance.getAllAccounts();
    if (all.length > 0 && !msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(all[0]);
    }

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  });
}
